import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CompaniesCreditsList.css';
import _ from 'lodash';
import moment from 'moment';
import {Table, Button, Input} from 'reactstrap';
import Select from '../../../commonComponents/customSelect/CustomSelect.container';
import ContactDataModal from './contactDataModal/ContactDataModal.container';
import PaginationCompaniesCredits from '../../../commonComponents/paginationComponent/PaginationCompaniesCredits.container';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { CURRENCIES } from '../../../../constants/constants';
import { COMPANIES_CREDITS_SORTING } from '../../../../reducers/systemPayments/companiesCredits';
import { Utils } from '../../../../utils/utils';
import CreditsHistoryModal from './creditsHistoryModal/CreditsHistoryModal.container';

class CompaniesCreditsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentContactData: null,
            nameFilter: '',
            countryFilter: null,
            continentFilter: null,
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        return (
            <div className='companies-credits-component-container'>
                <div className="controls-container">
                    {this.renderSorting()}
                    {this.renderNameFilter()}
                    {this.renderContinentAndCountryFilter()}
                </div>
                <PaginationCompaniesCredits />
                {this.renderContent()}
                <ContactDataModal contactData={this.state.currentContactData} />
                <CreditsHistoryModal />
            </div>
        )
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="companies-credits-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="companies-credits-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, 'system_payment.no_companies_credits_label')}</h6>
                </div>
            );
        }
        return (
            <Table className='companies-credits-table'>
                <thead>
                    <tr>
                        <th>{_.get(this.props.translation, 'system_payment.name_label')}</th>
                        <th>{_.get(this.props.translation, 'system_payment.date_joined_label')}</th>
                        <th>{_.get(this.props.translation, 'system_payment.open_credit_label')}</th>
                        <th className='centered'>{_.get(this.props.translation, 'system_payment.total_credit_label')}</th>
                        <th>{_.get(this.props.translation, 'system_payment.contact_label')}</th>
                        <th>{_.get(this.props.translation, 'main.payments_history_shirt_page_button')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderCreditsData()}
                </tbody>
            </Table>
        )
    }

    getTotalCreditLabel = (totalCredit) => {
        if (_.isEmpty(totalCredit)) {
            return "-";
        }
        return totalCredit.map(pay => Math.abs(pay.amount) + " " + CURRENCIES[pay.currency]).join(', ');
    };

    renderCreditsData() {
        return _.map(this.props.data, (data, index) => (
            <tr key={index}>
                <td className='name-td' data-th={_.get(this.props.translation, 'system_payment.name_label') + ':'}>
                    {data.name}
                </td>
                <td className='date-joined-td' data-th={_.get(this.props.translation, 'system_payment.date_joined_label') + ':'}>
                    {moment(data.joinDate).format('L')}
                </td>
                <td className='open-credit-td' data-th={_.get(this.props.translation, 'system_payment.open_credit_label') + ':'}>
                    {data.openCredit.amount + " " + CURRENCIES[data.openCredit.currency]}
                </td>
                <td className='total-credit-td centered' data-th={_.get(this.props.translation, 'system_payment.total_credit_label') + ':'}>
                    {this.getTotalCreditLabel(data.totalCredit)}
                </td>
                <td className='contact-data-td' data-th={_.get(this.props.translation, 'system_payment.contact_label') + ':'}>
                    <Button color="link" size="sm" onClick={this.onShowContactDataClick(data.contactData)}>
                        {_.get(this.props.translation, 'system_payment.show_label')}
                    </Button>
                </td>
                <td className='history-data-td' data-th={_.get(this.props.translation, 'main.payments_history_shirt_page_button') + ':'}>
                    <Button color="link" size="sm" onClick={this.onShowHistoryClick(data.id, data.name)}>
                        {_.get(this.props.translation, 'system_payment.show_label')}
                    </Button>
                </td>
            </tr >
        ))
    }

    renderSorting = () => {
        let options = [
            { value: COMPANIES_CREDITS_SORTING.NAME, label: _.get(this.props.translation, 'system_payment.name_label') },
            { value: COMPANIES_CREDITS_SORTING.CREATED_AT, label: _.get(this.props.translation, 'system_payment.date_joined_label') }
        ];

        return (
            <div className="sorting-container">
                <h6>{_.get(this.props.translation, 'system_payment.order_by_label')}</h6>
                <Select
                    className="sorting-select"
                    selectedOption={_.find(options, option => option.value === this.props.sorting)}
                    options={options}
                    onSelect={this.handleChangeSortingSelect}
                />
            </div>
        )
    };

    handleChangeSortingSelect = (selectedOption) => {
        this.props.onChangeSorting(selectedOption.value);
    };

    renderNameFilter = () => {
      return (
          <div className="name-filter-container">
              <h6 className="name-label">{_.get(this.props.translation, 'system_payment.name_label')}</h6>
              <Input
                  className="name-input"
                  type='text'
                  value={this.state.nameFilter}
                  onKeyDown={this.handleKeyDownNameFilter}
                  onChange={this.handleChangeNameFilter}
                  onBlur={this.handleBlurNameFilter}
              />
          </div>
      )
    };

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                Object.keys(this.props.locationData),
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.state.continentFilter ? this.props.locationData[this.state.continentFilter] : null,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return (
            <div className="continent-country-filter-container">
                <div className="continent-filter-container" key="continent-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                    <Select
                        className="continent-filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.state.continentFilter)}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentSelect}
                    />
                </div>
                <div className="country-filter-container" key="country-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="country-filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.state.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountrySelect}
                    />
                </div>
            </div>
        );
    };

    handleChangeContinentSelect = (selectedOption) => {
        if (this.state.continentFilter !== selectedOption.value) {
            this.props.onChangeContinentFilter(selectedOption.value);
            this.setState({countryFilter: null});
        }
        this.setState({continentFilter: selectedOption.value});
    };

    handleChangeCountrySelect = (selectedOption) => {
        if (!selectedOption.value) {
            this.props.onChangeContinentFilter(this.state.continentFilter);
        } else {
            this.props.onChangeCountryFilter(selectedOption.value);
        }
        this.setState({countryFilter: selectedOption.value});
    };

    handleChangeNameFilter = (e) => {
        this.setState({nameFilter: e.target.value});
    }

    handleKeyDownNameFilter = (e) => {
        if (e.keyCode === 13) {
            this.props.onChangeNameFilter(this.state.nameFilter || null);
        }
    }

    handleBlurNameFilter = () => {
        this.props.onChangeNameFilter(this.state.nameFilter || null);
    }

    onShowContactDataClick = (contactData) => () => {
        this.setState({ currentContactData: contactData });
        this.props.onShowContactDataModal();
    }

    onShowHistoryClick = (id, name) => () => {
        this.props.onShowHistoryModal(id, name);
    }
}

CompaniesCreditsList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.array,
    nameFilter: PropTypes.string,
    locationData: PropTypes.object,
    onMount: PropTypes.func.isRequired,
    onShowContactDataModal: PropTypes.func.isRequired,
    onChangeSorting: PropTypes.func.isRequired,
    onChangeNameFilter: PropTypes.func.isRequired,
    onChangeContinentFilter: PropTypes.func.isRequired,
    onChangeCountryFilter: PropTypes.func.isRequired,
    onShowHistoryModal: PropTypes.func.isRequired,
};

export default CompaniesCreditsList;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/companiesCreditsList/CompaniesCreditsList.js